import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../../modals/Modal';
// Components
import Heading from '../../shared/atoms/Heading';
import BillingAddressForm from './BillingAddressForm';

const BillingAddressModal = ({
  open,
  onRequestClose,
  clientId,
  mode = 'create',
  address,
  onSuccess,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      zIndex="1002"
      width="small"
      hasCloseAction={true}
      open={open}
      onRequestClose={onRequestClose}>
      <Heading mb={4} level={5}>
        {mode === 'edit'
          ? t('billingaddresses.modal.edit.title')
          : t('billingaddresses.modal.create.title')}
      </Heading>
      <BillingAddressForm
        clientId={clientId}
        mode={mode}
        address={address}
        onSuccess={onSuccess}
      />
    </Modal>
  );
};

export default BillingAddressModal;
